import { get, post } from "@insite/client-framework/Services/ApiService";

export interface  PIMExportApiResultModel {
    isSuccess: boolean;
    message: string;
    loading: boolean;
}

const PIMExportUrl = "/api/v2/PIMExport/NewExport"; 
const PIMCreateCustomerTemplate = "/api/v2/PIMExport/CreateCustomerTemplate";

export async function exportPIMData(parameter: any) {
   const response = await post<PIMExportApiResultModel>(PIMExportUrl,parameter);
   return response;
}

export async function pimCreateCustomerTemplate(parameter: any) {
    const response = await post<PIMExportApiResultModel>(PIMCreateCustomerTemplate,parameter);
    return response;
}

